<template>
  <UInput
    v-model="model"
    size="lg"
    :type="passwordHidden ? 'password' : 'text'"
    :placeholder="placeholder"
    :aria-label="placeholder"
    :ui="{ trailingIcon: '' }"
  >
    <template #trailing>
      <UButton
        color="neutral"
        variant="link"
        :icon="passwordHidden ? 'i-heroicons-eye' : 'i-heroicons-eye-slash'"
        :aria-label="t('a11y.show-password')"
        :padded="false"
        @click="passwordHidden = !passwordHidden"
      />
    </template>
  </UInput>
</template>
<script setup lang="ts">
const model = defineModel<string>()

interface propsInterface {
  placeholder: string
}
withDefaults(defineProps<propsInterface>(), {})
const passwordHidden = ref(true)
</script>
